import { HttpStatusCode } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import ApexCharts from 'apexcharts';
import { DataService } from '../../../shared-services/cache-data.service';
import { SharedService } from '../../../shared-services/shared.service';
import { AlertService } from '../../alerts-management/services/alert.service';
import { Constants } from '../../enums/constants';
import { DashboardChartNumbersEnum, DashboardChartTypesEnum, DashboardDateFilterEnum } from '../../enums/dashboard-chart-types';
import { AlertResponseDto, ChartLabels, ChartResponseDto, DashboardResponseDto } from '../../models/dashboard.models';
import { DashboardService } from '../services/dashboard.service';
declare var $: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  public chartTimeVsTransaction: any;
  chartCSvsTransaction: any;
  chartCPOvsTransaction: any;
  chartData!: DashboardResponseDto;
  chartNumberEnum: any = DashboardChartNumbersEnum;
  form!: FormGroup;
  doughnutChart!: any;
  displayDate!: string;
  totalRecords!: number;
  alerts: AlertResponseDto[] = [];
  totalAlerts!: AlertResponseDto[];
  constructor(public _alertService: AlertService,
    public _sharedService: SharedService, private cachedService: DataService, private _dataService: DataService,

    private fb: FormBuilder, public _dashboardService: DashboardService) { }

  ngOnInit() {
    this.initForm();
    this.cachedService.menu.subscribe((x: any) => {
      if (x && x.data) {
        this.getDashboardData(this.form.get('TypeCSId')!.value);
        this.getAlerts();
      }
    });
    this.setDisaplyaDate();
  }
  get isoCurrencyCode() {
    return sessionStorage.getItem('ISOCurrencyCode');
  }
  private setDisaplyaDate() {
    let day = this.getDayName((new Date()).getDay());
    let month = this.getMonthName((new Date()).getMonth());
    let date = (new Date()).getDate();
    let year = (new Date()).getFullYear();
    this.displayDate = day + ', ' + month + ' ' + ' ' + date + ' ' + year;
  }

  getMonthName(monthNo: number) {
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    return monthNames[monthNo];
  }

  getDayName(dayNo: number) {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[dayNo];
  }
  initForm() {
    this.form = this.fb.group({
      TypeTimeId: ['2'],
      TypeCSId: ['2'],
      DateTypeId: ['0']
    });
  }
  ngAfterViewChecked() {
    if (this.chartData && !this.chartCSvsTransaction && !this.chartTimeVsTransaction) {
      this.prepareCharts();
    }
  }
 
  private prepareCharts(chartId: number | null = null) {
    if (chartId == DashboardChartNumbersEnum.Time || chartId == null) {
      this.renderTimeChart();
    }
    if (chartId == DashboardChartNumbersEnum.ChargeStations || chartId == null) {
      this.renderChargeStationChart();
    }
    this.renderDonutChart();
  }

  private renderDonutChart() {
    let xData = this.chartData.chargingStatusVsConnectorsChartData.map((x: ChartResponseDto) => x.chargingStatus);
    let yData: any = this.chartData.chargingStatusVsConnectorsChartData.map((x: ChartResponseDto) => x.connectors);
    if (yData.filter((x :any) => x == 0).length != yData.length) {
      this.doughnutChart = this.createDoughnutChart('DoughnutChart', { xLabel: 'Connectors', yLabel: 'Charging Status' } as ChartLabels, xData, yData);
      this.doughnutChart.render();
    } else {
      $('.dash-charging-points').hide();
    }
  }

  private renderTimeChart() {
    var hoursArr: any = [];
    if (this.chartTimeVsTransaction) {
      this.chartTimeVsTransaction.destroy();
    }
    this.chartData.timeVsTransactionChartData.map((x: any) => x.time).forEach(v => { hoursArr.push(this.getAMPMHours(v)); });
    this.chartTimeVsTransaction = this.createChart('ChartTimeVsTransaction', { xLabel: 'Time', color: '#254fd7', yLabel: this.getYAxisLabel(this.form.get('TypeTimeId')!.value) } as ChartLabels, hoursArr, this.getYAxisChartData(this.chartData.timeVsTransactionChartData, this.form.get('TypeTimeId')!.value));
    this.chartTimeVsTransaction.render();
  }

  ngOnDestroy() {
    if (this.doughnutChart) {
      this.doughnutChart.destroy();
    }
    this.chartCSvsTransaction.destroy();
    this.chartTimeVsTransaction.destroy();
  }
  private renderChargeStationChart() {
    if (this.chartCSvsTransaction) {
      this.chartCSvsTransaction.destroy();
    }
    let xDataCh2 = this.chartData.chargeStationVsTransactionChartData.map((x: ChartResponseDto) => x.stationName);
    this.chartCSvsTransaction = this.createChart('ChartCSVsTransaction', { xLabel: 'Charge Station', color: '#69A831', yLabel: this.getYAxisLabel(this.form.get('TypeCSId')!.value) } as ChartLabels, xDataCh2, this.getYAxisChartData(this.chartData.chargeStationVsTransactionChartData, this.form.get('TypeCSId')!.value));
    this.chartCSvsTransaction.render();
  }

  private getYAxisLabel(chartTypeId: string) {
    let yAxisLablesObj: any = {
      TransactionCount: 'No. of Transactions',
      EnergyConsumed: 'Energy Consumed',
      Revenue: 'Revenue'
    };
    return yAxisLablesObj[DashboardChartTypesEnum[Number(chartTypeId)]];
  }

  private getYAxisChartData(chartData: any, chartTypeId: string) {
    let yAxisDataObj: any = {
      TransactionCount: chartData.map((x: ChartResponseDto) => x.transactions),
      EnergyConsumed: chartData.map((x: ChartResponseDto) => x.energyConsumed),
      Revenue: chartData.map((x: ChartResponseDto) => x.revenue)
    };
    let yData = yAxisDataObj[DashboardChartTypesEnum[Number(chartTypeId)]];
    return yData;
  }

  getAMPMHours(hours: number) {
    var AmOrPm = hours >= 12 ? 'PM' : 'AM';
    return ((hours % 12) || 12) + AmOrPm;
  }

  createDoughnutChart(id: string, labels: ChartLabels, xData: any, yData: any) {
    return new ApexCharts(document.getElementById(id), {
      series: yData,
      chart: {
        height: 320,
        type: 'donut',
        toolbar: {
          show: true,
          tools: {
            download: false
          }
        }
      },
      labels: xData,
      colors: ['#69A831', //green
        '#D8D8D8', //light gray
        '#EAC20D', // yellow
        '#707070', // grey
        '#254fd7', // blue
        '#E51638', //red
      ],
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val + (val > 1 ? ' Connectors' : ' Connector')
          }
        }, x: {
          formatter: function (val: any) {
            return 'Charging Status: ' + val
          }
        }
      }
    });
  }
  createChart(id: string, labels: ChartLabels, xData: any, yData: any) {
    return new ApexCharts(document.getElementById(id), {
      series: [{
        name: labels.yLabel,
        data: yData
      }],
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: true,
          tools: {
            download: false
          }
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        title: {
          text: labels.xLabel
        },
        categories: xData,
      },
      colors: labels.color,
      yaxis: {
        title: {
          text: labels.yLabel
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val + (labels.yLabel.toLowerCase().includes('revenue') ? sessionStorage.getItem('ISOCurrencyCode') : (labels.yLabel.toLowerCase().includes('energy') ? " kWh" : ""))
          }
        }
        , x: {
          formatter: function (val: any) {
            return labels.xLabel + " : " + val
          }
        }
      }
    });
  }

  async filterCharts() {
    await this._dashboardService.getTimeVsTransactionChartData({ month: this.form.get('DateTypeId')?.value == DashboardDateFilterEnum.ThisMonth ? ((new Date()).getMonth() + 1).toString() : null, year: this.form.get('DateTypeId')?.value == DashboardDateFilterEnum.ThisYear ? (new Date()).getFullYear().toString() : null, chartId: this.form.get('TypeTimeId')?.value }).then((x: any) => {
      if (x.code == HttpStatusCode.Ok && x.data) {
        this.chartData.timeVsTransactionChartData = x.data;
        this.renderTimeChart();
      }
    })
    await this._dashboardService.getChargeStationVsTransactionChartData({ month: this.form.get('DateTypeId')?.value == DashboardDateFilterEnum.ThisMonth ? ((new Date()).getMonth() + 1).toString() : null, year: this.form.get('DateTypeId')?.value == DashboardDateFilterEnum.ThisYear ? (new Date()).getFullYear().toString() : null, chartId: this.form.get('TypeCSId')?.value }).then((x: any) => {
      if (x.code == HttpStatusCode.Ok && x.data) {
        this.chartData.chargeStationVsTransactionChartData = x.data;
        this.renderChargeStationChart();
      }
    })
  }

  async getDashboardData(typeId: number, filterApplied: boolean = false, chartNumber: number | null = null) {
    await this._dashboardService.getDashboardData({ month: this.form.get('DateTypeId')?.value == DashboardDateFilterEnum.ThisMonth ? ((new Date()).getMonth() + 1).toString() : null, year: this.form.get('DateTypeId')?.value == DashboardDateFilterEnum.ThisYear ? (new Date()).getFullYear().toString() : null, chartId: typeId }).then((x: any) => {
      if (x.code == HttpStatusCode.Ok && x.data) {
        this.chartData = x.data;
        if (filterApplied) {
          this.prepareCharts(chartNumber);
        }
      }
    })
  }
  async getAlerts() {
    await this._alertService.SearchAlerts({ ChartId: null, PageNumber: 1, PageSize: 10 }).then((x: any) => {
      if (x.code == HttpStatusCode.Ok && x.data) {
        this.totalAlerts = x.data;
        this.alerts = x.data.slice(0, 7);
        this.totalRecords = 7;
        //this.totalRecords = x.data && x.data.length > 0 ? x.data[0].totalRecords : 0;
      }
    });
  }
}
